'use client';

import { useAuth } from 'react-oidc-context';
import styled from 'styled-components';

import { Sheet } from '@zoomit/mobile-sheet';
import { Box, Modal, Portal } from '@zoomit/primitives';
import type { BaseImageType} from '@zoomit/web-kit';
import { PriceNotifyPop, UnauthorizedModal, isMobile } from '@zoomit/web-kit';
import { Typography, theme } from '@zoomit/zoomit-ds';

type Props = {
  image: BaseImageType;
  title: string;
  productId: string;
  isPriceNotifyShow: boolean;
  onClose(): void;
  onSetNotify(): void;
};

const PriceNotifyModal = (props: Props) => {
  const { image, title, isPriceNotifyShow, onClose, onSetNotify } = props;

  const { isAuthenticated } = useAuth();

  if (!isPriceNotifyShow) {
    return null;
  }

  if (!isAuthenticated) {
    return <UnauthorizedModal isOpen={isPriceNotifyShow} onClose={onClose} />;
  }

  return isMobile ? (
    <Sheet isOpen={isPriceNotifyShow} onClose={onClose}>
      <Sheet.Container>
        <Sheet.Header>
          <Box spacing={{ pt: 'x10', px: 'x11', pb: 'x' }}>
            <Title>
              <Typography fontSize={1.6} fontWeight="bold">
                دریافت اعلانیه تغییرات قیمت
              </Typography>
            </Title>
          </Box>
        </Sheet.Header>
        <Sheet.Content>
          <PriceNotifyPop image={image} title={title} onClose={onClose} onSetNotify={onSetNotify} />
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop />
    </Sheet>
  ) : (
    <Portal>
      <Modal isOpen={isPriceNotifyShow} onClose={onClose}>
        <PriceNotifyPop image={image} title={title} onClose={onClose} onSetNotify={onSetNotify} />
      </Modal>
    </Portal>
  );
};

export default PriceNotifyModal;

const Title = styled.div`
  position: relative;
  margin-right: 1.6rem;

  &::before {
    content: '';
    position: absolute;
    width: 4px;
    height: 100%;
    top: 0;
    right: -1.6rem;
    background-color: var(${theme.primary1});
  }
`;
